import { render, staticRenderFns } from "./Workload.vue?vue&type=template&id=94c3fd1a&scoped=true"
import script from "./Workload.vue?vue&type=script&lang=js"
export * from "./Workload.vue?vue&type=script&lang=js"
import style0 from "./Workload.vue?vue&type=style&index=0&id=94c3fd1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c3fd1a",
  null
  
)

export default component.exports